import React, { useEffect, useRef } from "react";
import styles from "./css/style.module.css";
import { MdMenu } from "react-icons/md";
import { Dropdown } from "../";
// import { Notification } from "../";
import useScreenSize from "../../util/useScreenSize";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// importing actions
import { staffLogout } from "../../store/Auth/actions";
import { getProjectListStart, selectProject } from "../../store/Project/actions";

const Navbar = ({ fullScreen, setScreen }) => {
  const screen = useScreenSize();
  const dispatch = useDispatch();
  const staffUser = useSelector((state) => state.Auth.staffUser);
  const selectedProject = useSelector(state => state?.project?.selected_project);
  const projectList = useSelector((state) => state?.project?.project_list?.data || []);
  const loadingProjectList = useSelector((state) => state?.project?.loading_project_list);
  const AdminProfile = useSelector((state) => state.AdminProfile);
  const hasLoadedProjects = useRef(false);

  useEffect(() => {
    if (hasLoadedProjects.current || !staffUser) return;

    hasLoadedProjects.current = true;
    dispatch(getProjectListStart({ page: 0, size: 200 }));
  }, [dispatch, staffUser]);

  useEffect(() => {
    if (!selectedProject || loadingProjectList || projectList.length === 0) return;

    const availableProject = projectList.find(
      (project) => String(project?.id) === String(selectedProject?.id)
    );

    if (!availableProject) {
      dispatch(selectProject(projectList[0]));
    }
  }, [dispatch, loadingProjectList, projectList, selectedProject]);

  function profile_picture() {
    if (AdminProfile?.update?.response) {
      return (
        process.env.REACT_APP_IMAGE_BASE_PATH +
        AdminProfile?.update?.response?.profile_picture
      );
    } else {
      return staffUser?.profile_picture
        ? staffUser?.profile_picture?.includes("http")
          ? staffUser?.profile_picture
          : process.env.REACT_APP_IMAGE_BASE_PATH + staffUser?.profile_picture
        : `https://ui-avatars.com/api/?background=0D8ABC&color=fff&name=${staffUser?.name?.replace(
          " ",
          "+"
        )}`;
    }
  }

  return (
    <nav className={styles.container}>
      <div className={styles.navbar}>
        {screen < 450 ? (
          <MdMenu
            onClick={() => {
              setScreen(!fullScreen);
            }}
          />
        ) : (
          ""
        )}
        <div>
          <Link to="/dashboard">
            <img
              className={styles.navbar_icon}
              src="/image/app-icon.png"
              alt="admin-logo"
              onClick={() => {
                console.log(12345678);
              }}
            />
          </Link>
        </div>

        {/* <SearchBox style={{ width: "40%", marginLeft: "auto" }} /> */}

        <ul className={styles.nav} style={{ width: "fit-content" }}>
          <li className={styles.nav_item}>
            <Dropdown
              left
              title={
                <span className={styles.selected_project}>
                  {selectedProject?.name || "Choose Project"}
                </span>
              }
            >
              {loadingProjectList ? (
                <Dropdown.Item>
                  <span className={styles.project_option}>Loading projects...</span>
                </Dropdown.Item>
              ) : projectList.length > 0 ? (
                projectList.map((project) => (
                  <Dropdown.Item key={project?.id}>
                    <button
                      type="button"
                      className={styles.project_option}
                      onClick={() => dispatch(selectProject(project))}
                    >
                      {project?.name}
                    </button>
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item>
                  <span className={styles.project_option}>No projects available</span>
                </Dropdown.Item>
              )}
            </Dropdown>
          </li>
          {staffUser?.type === "admin" && (
            <li className={styles.user_type}>Admin</li>
          )}
          {staffUser?.type === "security" && (
            <li className={styles.user_type}>Security</li>
          )}
          {staffUser?.type === "supervisor" && (
            <li className={styles.user_type}>Supervisor</li>
          )}
          {staffUser?.type === "technician" && (
            <li className={styles.user_type}>Technician</li>
          )}
          {staffUser?.type === "cleaner" && (
            <li className={styles.user_type}>Cleaner</li>
          )}
          {staffUser?.type === "project_manager" && (
            <li className={styles.user_type}>Project Manager</li>
          )}
          {staffUser?.type === "super_user" && (
            <li className={styles.user_type}>Super User</li>
          )}
          {staffUser?.type === "sub_admin" && (
            <li className={styles.user_type}>Sub Admin</li>
          )}
          {/* <li className={styles.nav_item}>
                        <Dropdown
                          left
                          title={
                            <>
                              <MdNotificationsNone className={styles.notification} />
                              <span className={styles.notification_counter}>5</span>
                            </>
                          }
                        >
                          <Notification title="Alerts Center" footer="Show all alerts">
                            <Notification.Item>
                              <Notification.Icon icon="/logo192.png" />
                              <Notification.Message>
                                <p className="m-0" style={{ fontSize: "8px" }}>
                                  23-jun-2022
                                </p>
                                <p className="m-0">thie is message</p>
                              </Notification.Message>
                            </Notification.Item>
                            <Notification.Item>
                              <Notification.Icon icon="/logo192.png" />
                              <Notification.Message>
                                <p className="m-0" style={{ fontSize: "8px" }}>
                                  23-jun-2022
                                </p>
                                <p className="m-0">thie is message</p>
                              </Notification.Message>
                            </Notification.Item>
                          </Notification>
                        </Dropdown>
                      </li>
                      <li className={styles.nav_item}>
                        <Dropdown
                          left
                          title={<MdOutlineSettings className={styles.notification} />}
                        >
                          <Notification title="Message Center" footer="Show all alerts">
                            <Notification.Item>
                              <Notification.Icon icon="/logo192.png" />
                              <Notification.Message>
                                <p className="m-0" style={{ fontSize: "8px" }}>
                                  23-jun-2022
                                </p>
                                <p className="m-0">thie is message</p>
                              </Notification.Message>
                            </Notification.Item>
                          </Notification>
                        </Dropdown>
                      </li> */}
          <li className={styles.nav_item}>
            <Dropdown
              left
              title={
                <div className={styles.profileContainer}>
                  <img
                    className={styles.profilepic}
                    src={profile_picture()}
                    alt=""
                  />
                </div>
              }
            >
              <Dropdown.Item>
                <Link to={"/user-profile"} className={styles.admindropdownItem}>
                  Profile
                </Link>
              </Dropdown.Item>

              <Dropdown.Item>
                <Link
                  className={styles.admindropdownItem}
                  to={"/"}
                  onClick={() => {
                    window.localStorage.clear();
                    // window.localStorage.removeItem("filterOptions");
                    dispatch(staffLogout())
                  }}
                >
                  Logout
                </Link>
              </Dropdown.Item>
            </Dropdown>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
